import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import type { DashboardMonthOption } from '../../../../models/api.models';

@Component({
  selector: 'app-dashboard-period-filter',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dashboard-period-filter.component.html',
  styleUrl: './dashboard-period-filter.component.css'
})
export class DashboardPeriodFilterComponent {
  @Input({ required: true }) startDate!: string;
  @Input({ required: true }) endDate!: string;
  @Input({ required: true }) activePeriodLabel!: string;
  @Input({ required: true }) standardWeekHelp!: string;
  @Input() monthOptions: DashboardMonthOption[] = [];
  @Input() selectedMonth = 'manual';
  @Input() monthStatusLabel = '';
  @Input() busy = false;

  @Output() monthChange = new EventEmitter<string>();
  @Output() startDateChange = new EventEmitter<string>();
  @Output() endDateChange = new EventEmitter<string>();
  @Output() apply = new EventEmitter<void>();
  @Output() resetDefault = new EventEmitter<void>();
}
